import { type DirectusUser, readMe } from '@directus/sdk'
import { useNuxtApp } from '#imports'
import { useUserStore } from '~/store/user'

export type TLoginCredentials = {
  email: string;
  password: string;
  otp?: string;
};

export function useUser () {
  const { $directus } = useNuxtApp()

  const userStore = useUserStore()
  /* authenticate credentials & get user */
  const login = async ({ otp, ...payload }: TLoginCredentials) => {
    const data = await $directus.login(payload, otp ? { otp } : undefined)
    userStore.setAuth(data)
    await getDirectusUser()
  }

  /* fetch a user belonging to an auth object */
  const getDirectusUser = async () => {
    const user = await $directus.request(readMe())
    userStore.setUser(user as DirectusUser)
  }

  /* clear all auth / user related references */
  const logout = async () => {
    if (userStore.getAuth) {
      try {
        await $directus.logout()
      } catch (error) {
        console.warn(error)
      }
    }

    userStore.setAuth(undefined)
    userStore.setUser(undefined)
  }

  return { login, logout }
}
